<template>
  <div>
    <h1 class="h2 mt-4 mb-3">Material Shipments</h1>
    <div v-for="prioKey in [1, 2, 3, 0]" :key="prioKey">
      <div class="list-group" v-if="shipmentsByPrio[prioKey]">
        <h2 class="h4 mt-3 mb-3">Prio {{ prioKey }}</h2>
        <router-link
          v-for="shipment in shipmentsByPrio[prioKey]"
          :key="shipment.id"
          :to="`/materialshipments/${shipment.id}`"
          class="list-group-item list-group-item-action"
        >
          <div class="d-flex justify-content-between align-items-center">
            <span>{{ shipment.receiver.name }}</span>
            <span>{{ shipment.createdAt.toDate() | date }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div v-if="Object.keys(shipmentsByPrio).length === 0" class="alert alert-info" role="alert">No Open Orders</div>
  </div>
</template>

<script>
export default {
  computed: {
    shipmentsByPrio() {
      const prios = {
        1: [],
        2: [],
        3: [],
        0: []
      }
      this.$store.getters.materialShipments.forEach(shipment => {
        const whPrio = typeof shipment.whPrio !== 'undefined' ? shipment.whPrio : 2
        prios[whPrio].push(shipment)
      })
      Object.keys(prios).forEach(prioKey => {
        if (prios[prioKey].length === 0) delete prios[prioKey]
      })
      return prios
    }
  },
  filters: {
    date(date) {
      return date.toLocaleString('de-DE', { hour: '2-digit', minute: '2-digit', month: '2-digit', day: '2-digit' })
    }
  }
}
</script>
